import React from 'react'
import { connect } from 'react-redux'
import {  Row,  Table } from 'react-bootstrap'

import SearchBarDashboard from '../../../components/SearchBarDashboard'
import PropertyTitle from '../../../components/PropertyTitle'
import 'react-toggle/style.css'
import Toggle from 'react-toggle'
import DateInput from '../../../components/DateInput'
import * as Util from '../../../services/util'

import { SEARCH_INSTRUCTIONS, NO_SEARCH_RESULTS } from '../../messages'
import { fetchLicensesByActivationCodeOrUserId, updateLicense, fetchLicense } from '../../../actions/license-actions'

const Checkbox = ({ checked, onChange }) => (
  <label className="toggle" style={{padding:"10px", paddingLeft:"5px", display:"inline-block"}} >
    <span className="label"></span>
    <Toggle
      checked={checked}
      icons={{
        checked: null,
        unchecked: null,
      }}
      onChange={onChange}
    />
  </label>
)

class LicenseEditionOverview extends React.Component {

    constructor() {
        super()
        this.state = { query: undefined, overViewmode: true, detailMode:false, page: undefined,
          editingMode:false, selectedLicense:undefined, editedLicense:undefined, toggleValue:false, isSearching: false  }
      }
    
      componentDidMount() {
        if(this.props.results.query) {
          this.setState({ query: this.props.results.query })
        }
        if(this.props.results.length) {
          this.setState({ license: this.props.results[0] })
        }
      }

      componentWillUnmount() {
        this.setState({ query: undefined, overViewmode: true, detailMode:false, page: undefined,
          editingMode:false, selectedLicense:undefined, editedLicense:undefined, toggleValue:false })
      }

      search(query) {
        this.setState({ query, overViewmode: true, isSearching: true })
        const page = this.state.page ? this.state.page : 1
        this.props.fetchLicensesByActivationCodeOrUserId(query, page).then(() => {
          this.setState({ isSearching: false })
        })
      }

      onChangeActivationUrl(e) {
        var lic = this.state.editedLicense
        lic.activationPageUrl = e.target.value
        this.setState({editedLicense : lic})
      }

      onChangeActivateBefore(e) {

        var lic = this.state.editedLicense
        lic.activateBefore = e
        this.setState({editedLicense : lic})
      }

      onChangeActivationFrom(e) {
        var lic = this.state.editedLicense
        lic.activateFrom = e
        this.setState({editedLicense : lic})
      }

      onChangeExtendBefore(e) {

        var lic = this.state.editedLicense
        lic.extendBefore = e
        this.setState({editedLicense : lic})
      }

      onChangeExtendAfter(e) {
        var lic = this.state.editedLicense
        lic.extendAfter = e
        this.setState({editedLicense : lic})
      }


      persistLicense() {
        this.setState({selectedLicense: this.state.editedLicense})
        //save
        this.props.updateLicense(this.state.selectedLicense).then(() => {
          this.props.fetchLicense(this.state.selectedLicense.id);
          const page = this.state.page ? this.state.page : 1
          this.props.fetchLicensesByActivationCodeOrUserId(this.state.query, page);
        });
        this.changeToOverview();
      }

      changeToDetailMode(product){
        this.setState({overViewmode: false})
        this.setState({detailMode: true})
        this.setState({editingMode: false})
        this.setState({selectedLicense: product})
      }

      changeToOverview(){
        this.setState({overViewmode: true})
        this.setState({detailMode: false})
        this.setState({editingMode: false})
      }

      changeToEditingMode(){
        this.setState({editedLicense: this.state.selectedLicense})
        this.setState({overViewmode: false})
        this.setState({detailMode: false})
        this.setState({editingMode: true})
        this.setState({toggleValue: this.state.selectedLicense.deactivationPossible})
      }

      getDate(date){
        const dateToReturn = [...date];
        if(dateToReturn && dateToReturn.length === 3 ) {
          return new Date(date);
        }
        return date;
      }
    
      render() {
        const { results } = this.props
    
        return <div className='content-changeUserId' >
          <Row className='dashboardRowContainer'>
            <PropertyTitle 
              icon='key' 
              text=" Licentieoverzicht" 
            />
          <Row >
            <div style={{border:"solid", borderWidth:"1px", borderColor:"lightgray", padding:"10px"}}>
              <div style={{borderBottom:"solid", borderWidth:"1px", borderColor:"lightgray", padding:"5px",  marginBottom:"10px"}}>
                Zoek 
                </div>
                <SearchBarDashboard style={{ backgroundColor:"white", padding:"5px",  marginTop:"5px"}}
                placeholder="Zoek EAN"
                value={this.state.query || this.props.results.query}
                callback={(query) => this.search(query)}
                isLoading={this.state.isSearching}
                />
              </div>
          </Row>
          </Row>
        <Row>
          <div className="tablescontainer" style={{marginTop:"5px"}}>
            { this.state.overViewmode && results.length? (
              <Table striped>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>User Id</th>
                    <th>Activate before</th>
                    <th>Activation Code</th>
                    <th>Navision Id</th>
                    <th>Product Id</th>
                    <th>Blocked</th>
                  </tr>
                </thead>
                <tbody>
                  {results.map((license, index) => (
                    <tr key={index} onClick={(e) => this.changeToDetailMode(license)}>
                    <td style={{verticalAlign:"middle"}}>{license.id}</td>
                    <td style={{verticalAlign:"middle"}}>{license.user ? license.user.id : ""}</td>
                    <td style={{verticalAlign:"middle"}}>{license.activateBefore ? Util.getDutchFormattedDate( license.activateBefore ) : ""}</td>
                    <td style={{verticalAlign:"middle"}}>{license.activationCode ? license.activationCode : ""}</td>
                    <td style={{verticalAlign:"middle"}}>{license.navisionId ? license.navisionId : "" }</td>
                    <td style={{verticalAlign:"middle"}}>{license.product? license.product.id : ""}</td>
                    <td><Checkbox checked={license.blocked? true : false } onChange={e => {}} /></td>
                  </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              this.state.query && !this.state.isSearching ? <div>{NO_SEARCH_RESULTS}</div> : <div />
            )}
          </div>
        </Row>
        <Row>
        <div className="tablescontainer" style={{marginTop:"-65px", width:"50%" }}>
          { this.state.detailMode === true  && this.state.selectedLicense ?
          ( 
          <Table className='DashboardProductDetail' style={{display:"inline-flex"}} striped>
            <thead className='DashboardProductDetailThead' style={{backgroundColor:"none"}}>
              <tr>
              <th style={{fontWeight:"bold", color:"black"}} >{this.state.selectedLicense.ean}</th>
              <th></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>ID</td>
                <td>{this.state.selectedLicense.id}</td>
              </tr>
              <tr>
                <td>User ID</td>
                <td>{this.state.selectedLicense.user? this.state.selectedLicense.user.id : ""}</td>
              </tr>
              <tr>
                <td>Start datum</td>
                { this.state.selectedLicense.startDate ?
                <td> {Util.getDutchFormattedDate( this.state.selectedLicense.startDate ) } </td> :
                <button className="button-dashboard-product" onClick={() => {}}>Niets</button> }
              </tr>
              <tr>
                <td>Eind datum</td>
                { this.state.selectedLicense.endDate ?
                <td> {Util.getDutchFormattedDate( this.state.selectedLicense.endDate ) } </td> :
                <button className="button-dashboard-product" onClick={() => {}}>Niets</button> }
              </tr>
              <tr>
                <td>Activeren voor</td>
                { this.state.selectedLicense.activateBefore ?
                <td> {Util.getDutchFormattedDate( this.state.selectedLicense.activateBefore ) } </td> :
                <button className="button-dashboard-product" onClick={() => {}}>Niets</button> }
              </tr>
              <tr>
                <td>Activeren na</td>
                { this.state.selectedLicense.activateFrom ?
                <td> { Util.getDutchFormattedDate( this.state.selectedLicense.activateFrom ) } </td> :
                <button className="button-dashboard-product" onClick={() => {}}>Niets</button> }
              </tr>
              <tr>
                <td>Verlengen voor</td>
                { this.state.selectedLicense.extendBefore ?
                <td> { Util.getDutchFormattedDate( this.state.selectedLicense.extendBefore ) } </td> :
                <button className="button-dashboard-product" onClick={() => {}}>Niets</button> }
              </tr>
              <tr>
                <td>Verlengen na</td>
                { this.state.selectedLicense.extendAfter ?
                <td> { Util.getDutchFormattedDate( this.state.selectedLicense.extendAfter ) } </td> :
                <button className="button-dashboard-product" onClick={() => {}}>Niets</button> }
              </tr>
              <tr>
                <td>Activation Code</td>
                <td>{this.state.selectedLicense.activationCode ? this.state.selectedLicense.activationCode : ""}</td>
              </tr>
              <tr>
                <td>Navision Id</td>
                <td>{this.state.selectedLicense.navisionId ? this.state.selectedLicense.navisionId : ""}</td>
              </tr>
              <tr>
                <td>Product Id</td>
                <td>{this.state.selectedLicense.product ? this.state.selectedLicense.product.id : ""}</td>
              </tr>
              <tr>
                <td>geblokkeerd</td>
                <button className="button-dashboard-product" onClick={() => {}}>{this.state.selectedLicense.blocked ? 'Ja' : 'NEE' }</button>
              </tr>
            </tbody>
            <Row>
            <button className="button-dashboard-product" style={{marginLeft:"20px"}} onClick={() => this.changeToOverview()}>Terug naar overzicht</button>
            <button className="button-dashboard-product" onClick={() => this.changeToEditingMode()}>Bewerken</button>
            </Row>

          </Table>

          ) :
          (<div></div>)
          }
          </div>
        </Row>
        <Row>
        <div className="tablescontainer" style={{marginTop:"-50px" }}>
          { this.state.editingMode === true  && this.state.editedLicense ?
          ( 
          <Table className='DashboardProductDetail' style={{display:"inline" }} striped>
            <thead className='DashboardProductDetailThead' style={{backgroundColor:"none"}}>
              <tr>
              <th style={{fontWeight:"bold", color:"black"}} >Product Bewerken - {this.state.selectedLicense.ean}</th>
              <th></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Activeren voor</td>
                <td> <DateInput 
                  value={this.state.editedLicense.activateBefore ? this.getDate(this.state.editedLicense.activateBefore) : ""} 
                  placeholder={'Activeren voor'} 
                  onChange={(e) => this.onChangeActivateBefore(e)} /> </td>
              </tr>
              <tr>
                <td>Activeren na</td>
                <td> <DateInput 
                  value={this.state.editedLicense.activateFrom ? this.getDate(this.state.editedLicense.activateFrom) : ""} 
                  placeholder={'Activeren na' } 
                  onChange={(e) => this.onChangeActivationFrom(e)} /> </td>
              </tr>
              <tr>
                <td>Verlengen voor</td>
                <td> <DateInput 
                  value={this.state.editedLicense.extendBefore ? this.getDate(this.state.editedLicense.extendBefore) : ""} 
                  placeholder={'Verlengen voor'} 
                  onChange={(e) => this.onChangeExtendBefore(e)} /> </td>
              </tr>
              <tr>
                <td>Verlengen na</td>
                <td> <DateInput 
                  value={this.state.editedLicense.extendAfter ? this.getDate(this.state.editedLicense.extendAfter) : ""} 
                  placeholder={'Verlengen na' } 
                  onChange={(e) => this.onChangeExtendAfter(e)} /> </td>
              </tr>
            </tbody>
            <Row>
            <button className="button-dashboard-product-no-background" style={{marginLeft:"20px"}} onClick={() => this.changeToOverview()}>Annuleren</button>
            <button className="button-dashboard-product" onClick={() => this.persistLicense()}>opslaan</button>
            </Row>

          </Table>

          ) :
          (<div></div>)
          }
          </div>
        </Row>
        </div>
      }

    
}


  export default connect((state) => {
    return { 
    results: state.licenses.searchResults,
    selectedLicense: state.products.detail,
    query: state.dashboard.userLicenseSearchDashboard.query
  }}, {
    fetchLicensesByActivationCodeOrUserId,
    updateLicense,
    fetchLicense
  })(LicenseEditionOverview)